import {Pipe, PipeTransform} from '@angular/core';
import {FundProductTypesEnum, ProductSubType} from '@spa/api';
import {Helper} from '../classes';
import {LanguageService} from "../language.service";

@Pipe({
	name: 'productType'
})
export class ProductTypePipe implements PipeTransform {

	constructor(private languageService: LanguageService) {
	}

	transform(type: FundProductTypesEnum): string {
		return Helper.textsHelper().getProductTypeName(type, this.languageService.getCurrentLanguage());
	}
}
